import * as actionTypes from '../actions/actionTypes';

const initialState = {
    details:"data"
};

const setReplayer = ( state , action ) => {
    console.log('state-->',action.payLoad)
   return {...state, payLoad:action.payLoad }
     
};


const pwReplayer = ( state= initialState , action ) => {
    switch ( action.type ) {
        case actionTypes.SET_REPLAYER_STATS : return setReplayer(state,action)
        default:
            return state;
    }
};

export default pwReplayer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/pokerwatchPlayer.js
 **/